export const environment = {
  production: false,
  msalConfig: {
    auth: {
      clientId: '240069ed-a8b4-43ca-b7d0-082242e88e75',
      authority:
        'https://login.microsoftonline.com/99c75c69-9ef2-4c4e-b5e3-54b6cf95c977',
    },
  },
  apiConfig: {
    scopes: ['https://analysis.windows.net/powerbi/api/.default'],
    uri: 'https://api.powerbi.com/v1.0/myorg',
  },
  healthGuardApi: {
    uri: 'https://healthguard-api-dev-01.azurewebsites.net',
    // uri: 'http://localhost:8000',
    scopes: ['api://9ba87613-1a36-4102-8328-2bb78e61aa9a/.default'],
  },
  blueCreekAPI: {
    uri: 'https://func-bluecreek-prd-01.azurewebsites.net',
    scopes: ['api://c6963547-c103-4af7-96b3-283d2cd36e3d/user_impersonation'],
  },
  internalToolingAPI: {
    uri: 'https://web-internaltooling-api-dev-01.azurewebsites.net/',
    // uri: 'http://localhost:8000',
    scopes: ['api://37f9e57e-0c0d-4e75-be33-987c53dc11d0/.default'],
  },
};
